"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DirectiveNodeHandlerAdapter_1 = require("./DirectiveNodeHandlerAdapter");
/**
 * A handler for include directives.
 */


var DirectiveNodeHandlerInclude =
/*#__PURE__*/
function (_DirectiveNodeHandler) {
  _inherits(DirectiveNodeHandlerInclude, _DirectiveNodeHandler);

  function DirectiveNodeHandlerInclude(util, settings) {
    _classCallCheck(this, DirectiveNodeHandlerInclude);

    return _possibleConstructorReturn(this, _getPrototypeOf(DirectiveNodeHandlerInclude).call(this, 'include', util, settings));
  }

  _createClass(DirectiveNodeHandlerInclude, [{
    key: "handle",
    value: function handle(directiveContext, convertContext) {
      var val = this.getDirectiveConditionalValue(directiveContext.directive, convertContext);

      if (val.termType === 'Literal' && val.value === 'false') {
        return {
          ignore: true
        };
      }

      return {};
    }
  }]);

  return DirectiveNodeHandlerInclude;
}(DirectiveNodeHandlerAdapter_1.DirectiveNodeHandlerAdapter);

exports.DirectiveNodeHandlerInclude = DirectiveNodeHandlerInclude;